import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const path = '../oldPages/banner-management/list/index.html';

const links: Record<string, string> = {
  tab1: '/infoTrac/banner-management',
  tab2: '/infoTrac/banner-management/list',
};

function BannersList() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleIframeLoad = () => {
      const iframeDocument = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;

      if (!iframeDocument) return;

      const tab1 = iframeDocument.getElementById('tab1');
      const tab2 = iframeDocument.getElementById('tab2');

      const openModal = iframeDocument.getElementsByClassName('openModal');
      const closeModal = iframeDocument.getElementsByClassName('closeModal');

      if (openModal.length) {
        for (let i = 0; i < openModal.length; i++) {
          openModal[i].addEventListener('click', () => {
            document.body.classList.add('lightbox-open');
          });
        }
      }

      if (closeModal.length) {
        for (let i = 0; i < closeModal.length; i++) {
          closeModal[i].addEventListener('click', () => {
            document.body.classList.remove('lightbox-open');
          });
        }
      }

      if (tab1) tab1.addEventListener('click', () => navigate(links.tab1));
      if (tab2) tab2.addEventListener('click', () => navigate(links.tab2));
    };

    if (iframeRef.current) iframeRef.current.addEventListener('load', handleIframeLoad);

    return () => {
      if (iframeRef.current) iframeRef.current.removeEventListener('load', handleIframeLoad);
    };
  }, [navigate]);

  return (
    <iframe ref={iframeRef} title="banners-list" src={path} className="z-[100] relative" width="100%" height="800px" />
  );
}

export default BannersList;
